import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import styles from "../ProductReview/review.module.css";
import TopNavbar from "../../Component/TopMenu/TopNavbar";
import NavbarSection from "../../Component/NavbarSection/NavbarSection";
import { useNavigate } from "react-router-dom";
import { FaRegCheckCircle, FaEye } from "react-icons/fa";
import { RiCloseCircleLine } from "react-icons/ri";
import { FormatNumber } from "../../Component/FormatNumber/FormatNumber";
import NewPagination from "../../Component/NewPagination/NewPagination";
import NotFound from "../../Component/NotFound/NotFound";
import Moment from "react-moment";
import ViewDetailsModal from "./Modals/ViewDetailsModal";
import ConfirmActionModal from "./Modals/ConfirmActionModal";
import { BASE_URL } from "../../Apis/BaseUrl";
import axios from "axios";
import Cookies from "js-cookie";

const FranchiseWithdraw = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageInfo, setPageInfo] = useState({});
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [productSearch, setProductSearch] = useState("");

  // Modal states
  const [showViewModal, setShowViewModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [actionType, setActionType] = useState(""); // 'accept' or 'reject'

  const navigate = useNavigate();

  let profileTokenJson = Cookies.get("v&b_token");
  let profileToken = JSON.parse(profileTokenJson);
  let token = profileToken.token;

  // Get data from API
  const getData = async () => {
    setLoading(true);
    try {
      let res = await axios.get(
        `${BASE_URL}/franchise/withdrawal-requests-franchise?limit=${limit}&page=${page}&status=${productSearch}&search=${search}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Franchise withdrawal data:", res.data.message);
      setData(res.data.message?.docs || []);
      setPageInfo({ ...res.data.message, docs: null });
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [limit, page, productSearch, search]);

  useEffect(() => {
    setPage(1);
  }, [limit]);

  // Modal handlers
  const handleViewDetails = (item) => {
    setSelectedItem(item);
    setShowViewModal(true);
  };

  const handleAcceptClick = (item) => {
    setSelectedItem(item);
    setActionType("accept");
    setShowConfirmModal(true);
  };

  const handleRejectClick = (item) => {
    setSelectedItem(item);
    setActionType("reject");
    setShowConfirmModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setSelectedItem(null);
  };

  const handleCloseConfirmModal = () => {
    setShowConfirmModal(false);
    setSelectedItem(null);
    setActionType("");
  };

  const handleConfirmAction = async () => {
    try {
      const res = await getData();
      
      console.log("res", res);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Utility function to truncate notes
  const truncateText = (text, maxLength = 10) => {
    if (!text) return "-";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  const paginationProps = {
    setPage,
    pageInfo,
    setLimit,
  };

  console.log("Current filter:", productSearch);

  return (
    <React.Fragment>
      <Helmet>
        <title>Franchise Withdrawal Requests</title>
      </Helmet>
      <TopNavbar />
      <NavbarSection />

      {/* ----------Hero-Section----------- */}
      <div className={styles.hero_Section}>
        <div className={styles.product_review_section}>
          <h6 className="mb-0">Franchise Withdrawal Requests</h6>
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              height: "40px",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #d9d9d9",
              outline: "none",
            }}
            placeholder="Search franchise name or notes..."
            required
          />
        </div>

        <div className="mt-4">
          <div className={styles.filterData}>
            <p>Filters : </p>
            <p>Status </p>
            <div className="form-check">
              <input
                className={`${styles.form_check_input}`}
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault1"
                value=""
                onChange={(e) => setProductSearch(e.target.value)}
                checked={productSearch === ""}
              />
              <label
                className="form-check-label mx-1"
                htmlFor="flexRadioDefault1"
              >
                All
              </label>
            </div>
            <div className="form-check">
              <input
                className={`${styles.form_check_input}`}
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault2"
                value="approved"
                onChange={(e) => setProductSearch(e.target.value)}
                checked={productSearch === "approved"}
              />
              <label
                className="form-check-label mx-1"
                htmlFor="flexRadioDefault2"
              >
                Approved
              </label>
            </div>
            <div className="form-check">
              <input
                className={`${styles.form_check_input}`}
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault3"
                value="pending"
                onChange={(e) => setProductSearch(e.target.value)}
                checked={productSearch === "pending"}
              />
              <label
                className="form-check-label mx-1"
                htmlFor="flexRadioDefault3"
              >
                Pending
              </label>
            </div>
            <div className="form-check">
              <input
                className={`${styles.form_check_input}`}
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault4"
                value="rejected"
                onChange={(e) => setProductSearch(e.target.value)}
                checked={productSearch === "rejected"}
              />
              <label
                className="form-check-label mx-1"
                htmlFor="flexRadioDefault4"
              >
                Rejected
              </label>
            </div>
          </div>
        </div>

        {/* -------------table_section-------------- */}
        {data?.length > 0 ? (
          <>
            <div className={styles.main_table} style={{ overflowX: "auto" }}>
              <table className="table">
                <thead>
                  <tr>
                    <th className="px-5">Franchise Name</th>
                    <th>Date</th>
                    <th>Withdraw Request<br /> Amount</th>
                    <th>Available<br /> Amount</th>
                    <th>Notes</th>
                    <th>View</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={item._id}>
                      <td className="px-5 text-capitalize">
                        {item?.franchise?.name ||
                          item?.franchiseId?.name ||
                          "-"}
                      </td>
                      <td>
                        <Moment format="YYYY/MM/DD">{item.createdAt}</Moment>
                      </td>
                      <td>{FormatNumber(item?.amount ?? 0)}</td>
                      <td>{FormatNumber(item?.availableBalance ?? 0)}</td>
                      <td style={{ maxWidth: "120px" }}>
                        <span
                          title={item?.notes || item?.message || "No notes"}
                        >
                          {truncateText(item?.notes || item?.message)}
                        </span>
                      </td>
                      <td>
                        <FaEye
                          style={{ cursor: "pointer", fontSize: "18px" }}
                          className="text-primary"
                          onClick={() => handleViewDetails(item)}
                          title="View Details"
                        />
                      </td>
                      <td>
                        {item.status === "approved" ? (
                          <FaRegCheckCircle
                            className="text-success fs-5"
                            title="Approved"
                          />
                        ) : item.status === "rejected" ? (
                          <RiCloseCircleLine
                            className="text-danger fs-4"
                            title="Rejected"
                          />
                        ) : item.status === "pending" ? (
                          <div className="d-flex gap-2 align-items-center">
                            <FaRegCheckCircle
                              style={{ cursor: "pointer" }}
                              className="text-success fs-5"
                              onClick={() => handleAcceptClick(item)}
                              title="Approve Request"
                            />
                            <RiCloseCircleLine
                              style={{ cursor: "pointer" }}
                              className="text-danger fs-4"
                              onClick={() => handleRejectClick(item)}
                              title="Reject Request"
                            />
                          </div>
                        ) : null}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <NewPagination {...paginationProps} />
          </>
        ) : (
          <NotFound cls={styles.not_found} />
        )}
      </div>

      {/* Modals */}
      <ViewDetailsModal
        show={showViewModal}
        handleClose={handleCloseViewModal}
        selectedItem={selectedItem}
      />

      <ConfirmActionModal
        show={showConfirmModal}
        handleClose={handleCloseConfirmModal}
        actionType={actionType}
        selectedItem={selectedItem}
        onConfirm={handleConfirmAction}
      />
    </React.Fragment>
  );
};

export default FranchiseWithdraw;
